import styled from"@emotion/styled";import{Link}from"@wp/src/components/common";import Button from"@wp/src/components/common/button";import{Form,FormItem}from"@wp/src/components/common/form";import{mediaQuery}from"@wp/src/components/common/grid";import{Divider}from"antd";export const PasswordFlowFormContainer=styled.div`
  ${mediaQuery({minWidth:["320px","424px"],maxWidth:["320px","424px"]})}
`;export const FormHeaderLabel=styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;

  color: ${props=>props.theme.colors.neutral900};
`;export const StyledFormItem=styled(FormItem)`
  margin-bottom: 16px;

  .ant-form-item-label label {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    padding: ${props=>props.itemLabelPadding} !important;
    color: ${props=>props.theme.colors.neutral900};
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    display: none;
  }
  .ant-form-item-explain, .ant-form-item-explain-error {
    margin-top: 4px;
    margin-bottom: ${props=>props.itemHelpMarginBottom?props.itemHelpMarginBottom:"16px "};
    font-size: ${props=>props.itemHelpFontSize};
`;export const StyledForm=styled(Form)`
  padding-top: 20px;
`;export const SecondaryActionGuideContainer=styled.div`
  width: 100%;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;

  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props=>props.theme.colors.neutral900};
`;export const SecondaryActionButton=styled(Link)`
  padding: 0;
`;export const PrimaryActionAccountButtonContainer=styled.div`
  padding-top: 10px;
`;export const PrimaryActionAccountButton=styled(Button)`
  width: 100%;
`;export const SectionContainer=styled.div`
  width: 100%;
  height: ${props=>props.isTest70?null:"100%"};
  display: flex;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  ${props=>!props.isTest70&&mediaQuery({padding:["20px 15px","20px 15px","20px 15px","0"]})}

  background-color: ${props=>props.isTest70?null:props.theme.colors.white};
`;export const WelcomeContainer=styled(SectionContainer)`
  background: ${props=>props.theme.colors.blue900};
  align-items: center;
  justify-content: center;

  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: ${props=>props.theme.colors.neutral300};
`;export const WelcomeBlock=styled.div`
  max-width: 420px;
`;export const WelcomeLabel=styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
  color: ${props=>props.theme.colors.white};
  padding-bottom: 10px;
`;export const WelcomeDescription=styled.div``;export const MainContentRow=styled.div`
  min-height: inherit;
  display: flex;
  width: 100%;
  ${mediaQuery({flexDirection:["column","column","row-reverse"]})}
`;export const MainContentCol=styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex: 1 0 0;
`;export const StyledDivider=styled(Divider)`
  margin: ${props=>props.isMobile?"8px 0 0 0":"24px 0"} !important;
`;